import { render, staticRenderFns } from "./SwiperSlide.vue?vue&type=template&id=37c59f25"
import script from "./SwiperSlide.vue?vue&type=script&lang=ts"
export * from "./SwiperSlide.vue?vue&type=script&lang=ts"
import style0 from "./SwiperSlide.vue?vue&type=style&index=0&id=37c59f25&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports